"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = full;

var _environment = _interopRequireDefault(require("./environment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function full(setup, fn) {
  const environments = {};
  const initial = Object.entries(setup).reduce((acc, [key, value]) => {
    acc[key] = typeof value === 'object' ? value.from : value;
    return acc;
  }, {});
  return (0, _environment.default)(environments, initial, initial, setup, fn);
}